// ── IMMAGINI (Arti Marziali Bambini — Lezioni Pronte™, copia italiana) ────────────────────────────
// Mockup e pagine del libro italiano, caricati come media su Higgsfield (CloudFront).
// Elenco file → URL: productos/martial-arts-kids-it/landing/recursos.md
const CDN = 'https://d2ol7oe51mr4n9.cloudfront.net/user_3DMFLKCotDruk7RKAWz1zy5qmH0/';

/**
 * iMac con la copertina del libro italiano + 3 tablet + 2 smartphone, un bonus italiano per dispositivo. Sfondo bianco puro.
 */
const IMAC = CDN + '2d8dd914-f272-47d3-b6cd-9753b36a0f91.jpg'; // it-mockup-imac.jpg
export const heroMockupUrl = IMAC;
export const offerMockupUrl = IMAC;
/** Pagine vere del libro italiano (9:16), stesso ordine di lookInside.captions: p. 6, 8, 27, 22, 37, 39 */
export const pageImages: string[] = [
  CDN + '897e620c-87a9-4346-be47-2d5ca614e4f9.jpg', // it-pagina-06.jpg · piano di 52 settimane, 3° trimestre
  CDN + 'e7ec9fd6-9d50-45fb-90f9-c1e11728598a.jpg', // it-pagina-08.jpg · Lezione 01, piano della lezione
  CDN + 'ca36dfc1-7d2f-4b2c-a6c4-ee3033b65728.jpg', // it-pagina-27.jpg · Lezione 07, come spiegarla
  CDN + '51212b62-4482-422e-b3e3-7f12bf4a8133.jpg', // it-pagina-22.jpg · Lezione 05, esercizi e gioco
  CDN + 'd2b7d41e-931c-44e8-96e9-5b0ee15b2b1e.jpg', // it-pagina-37.jpg · Lezione 10, scheda dell’esame di prova
  CDN + '3f14695e-7967-41b2-bea3-14a6451dbde5.jpg', // it-pagina-39.jpg · scheda di pianificazione + registro delle tacche
];
/** 5 copertine dei bonus in italiano (generate dalla tienda italiana, stile Collage), nello stesso ordine dei bonus (e del checkout) */
const EB = 'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/ebook-images/a1a6d8ac-b9a6-46cd-90ac-c8629c68407c/';
export const bonusCovers: string[] = [
  EB + '9213c54d-e630-49e3-ab44-f4869e278d2f-mockup-gmvnwx9q8.webp',
  EB + 'f33d2fb9-e7fc-4f6f-998e-c66f58459bc1-mockup-gmvnwxfg8.webp',
  EB + 'cf830467-7e12-4f86-a76b-d4fb8feb64df-mockup-gmvnwypax.webp',
  EB + '0be4751b-7741-4ebd-9d55-a85ecb4058ef-mockup-gmvnx00w3.webp',
  EB + '183fb325-5b47-4b0c-966a-e6058fb29774-mockup-gmvnx1qq9.webp',
];
